import { io } from "socket.io-client";

let socket;

export const getChatSocket = () => {
  if (socket) return socket;

  const baseURL =
    String(window.location.href).indexOf("localhost") > -1
      ? "http://localhost:5000"
      : "https://api.antravelsint.com";
  const token = localStorage.getItem("user-token");

  socket = io(baseURL, {
    transports: ["websocket"],
    auth: {
      token: token ? `Bearer ${token}` : "",
    },
  });

  return socket;
};

export const disconnectChatSocket = () => {
  if (!socket) return;
  socket.disconnect();
  socket = null;
};
